import { useT } from "../../i18n/LanguageContext";

const itens = [
  { v: "80m", l: "🛒 Coviran" },
  { v: "150m", l: "🥖 Padaria" },
  { v: "200m", l: "⚽ Bar Clube" },
  { v: "300m", l: "💊 Farmácia" },
  { v: "400m", l: "🍷 Adega Vila Lisa" },
  { v: "500m", l: "🚂 Estação CP" },
  { v: "10 min", l: "🏙️ Portimão" },
  { v: "12 min", l: "🏖️ Praia Alvor" },
  { v: "15 min", l: "🌊 Três Irmãos" },
  { v: "18 min", l: "🌅 Meia Praia" },
  { v: "20 min", l: "🏛️ Lagos" },
  { v: "50 min", l: "✈️ Aer. Faro" },
];

export default function Distancias() {
  const { t } = useT();
  return (
    <section className="py-20 md:py-28 bg-noite text-[#faf6ee] relative overflow-hidden" data-testid="distancias-section">
      <div className="absolute -top-32 left-1/4 w-96 h-96 rounded-full bg-[#e3b25b]/8 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 text-center relative reveal">
        <p className="section-label justify-center">{t.distances.eyebrow}</p>
        <h2 className="font-display text-4xl md:text-5xl mt-4">
          {t.distances.title1} <em className="text-[#e3b25b]">{t.distances.title2}</em>
        </h2>
        <p className="mt-4 text-[#faf6ee]/70 max-w-xl mx-auto">{t.distances.subtitle}</p>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 relative">
        {itens.map((it) => (
          <div
            key={it.l}
            className="reveal bg-[#1a2c5c]/55 rounded-xl px-3 py-5 text-center ring-1 ring-white/10 card-lift"
            data-testid={`distancia-${it.l.replace(/\s/g, "-")}`}
          >
            <p className="font-display text-2xl md:text-3xl text-gold-metal leading-none font-medium">{it.v}</p>
            <p className="text-[11px] mt-2 text-[#faf6ee]/80 uppercase tracking-wider">{it.l}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
